// extracted by mini-css-extract-plugin
module.exports = {"sitemap":"styles_sitemap__5W4KI","pulse":"styles_pulse__soG9a","jump":"styles_jump__LZcda","wiggle":"styles_wiggle__51afc"};